import { DefaultPaymentMethod, DefaultPaymentMethodObj } from "../types/common/PaymentMethod";

export const defaultPaymentMethodItems: DefaultPaymentMethodObj[] = [
    { _id: 1, method: DefaultPaymentMethod.CreditCard, methodText: "Credit Card" },
    { _id: 2, method: DefaultPaymentMethod.IDEAL, methodText: "IDEAL" },
    { _id: 3, method: DefaultPaymentMethod.Paypal, methodText: "PayPal" },
    { _id: 4, method: DefaultPaymentMethod.Card, methodText: "Card" },
    { _id: 5, method: DefaultPaymentMethod.Cash, methodText: "Cash" }
];